<template lang="pug">
div()
  template(v-if="pageIndex == 0" )
    v-card(style="position:relative;width:600px")

      v-card-title.pl-6.grey.lighten-1.pt-8.pb-2.pr-2(style="width:500px;")
        .span(v-if="selectedVehicles.length > 0") {{selectedVehicles.length}} &nbsp;&nbsp;
        .span() Vehicles
        v-spacer()
        v-btn.mx-2(color="primary" small  @click="onDownload")
          v-icon(:size="16") download
          | Download
        v-btn.mx-2(color="primary" small  @click="onSendEmail")
          v-icon.mr-1(:size="16") email
          | Send Email
        v-btn.ml-2(outlined color="primary" small @click="onCancel")
          v-icon() close
      v-progress-linear( :indeterminate="loading" )

      div.mt-2()
        div.grey.lighten-2()
          v-row.mx-1()
            v-col(cols="6")
              v-menu(
                ref="startMenu"
                v-model="startMenu"
                :close-on-content-click="false"
                :return-value.sync="startDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              )
                template( v-slot:activator="{ on, attrs }")
                  v-text-field.pt-4.mt-2(
                    v-model="startDateFormatted"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :hide-details="true"
                  )
                v-date-picker(v-model="startDate"
                  no-title
                  scrollable
                  :max="getMaxNowDate"
                  @input="$refs.startMenu.save(startDate)"
                  )
            v-col(cols="6")
              v-menu(
                ref="endMenu"
                v-model="endMenu"
                :close-on-content-click="false"
                :return-value.sync="endDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :hide-details="true"
              )
                template( v-slot:activator="{ on, attrs }")
                  v-text-field.pt-4.mt-2(
                    v-model="endDateFormatted"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  )
                v-date-picker(v-model="endDate"
                  no-title
                  scrollable
                  @input="$refs.endMenu.save(endDate)"
                  :max="getMaxNowDate"
                  )


        div(style="position:relative;overflow-y:scroll; max-height:500px")
          v-data-table(
            :headers="headers"
            :items="$store.state.vehicles.all"
            item-key="id"
            :single-select="false"
            show-select
            v-model="selectedVehicles"
            :options="dataTableOptions"
            hide-default-footer
            @click:row="onClickRow"
          )
            template(v-slot:item.id="{item}")
              vehicle-column-by-id(:vehicle_id="item.id")

      v-divider()
      v-card-actions()
        v-layout(justify-end)
          .d-flex.align-end.grey--text.text--darken-2()
            v-icon.mr-2(color="amber" :size="20") warning
            .caption() <b>Email</b> and <b>Downloads</b> may take some time

  template(v-if="pageIndex == 1" )
    v-card()
      v-card-title.pl-8.grey.lighten-1.py-4(style="width:500px;") Vehicles Trip History
      v-card-text()
        .d-flex.flex-column.justify-center.align-center(style="height:300px")
          div.mb-8(v-html="responseString" )
          v-btn(color="primary" @click="$emit('closeTripDialog')") Close


</template>
<script>
import VehicleColumnById from "@/modules/global/components/table/VehicleColumnById.vue";
import moment from "moment";
import Repository from "@/repository";
export default {

  components:{
    VehicleColumnById
  },
  props:{

  },

  data: ()=> ({
    responseString: "",
    loading: false,
    pageIndex: 0,
    startMenu: false,
    startDate: moment().subtract(1,"week").format("YYYY-MM-DD"),

    endMenu: false,
    endDate: moment().format("YYYY-MM-DD"),

    dataTableOptions: {
      itemsPerPage: 1000,
    },
    selectedVehicles:[],
    headers: [
      {
        text: "Select Vehicles for Report",
        value: "id",
        align: "left"
      },
    ]
  }),
  computed:{

    getMaxNowDate() {
      return moment().format("YYYY-MM-DD");
    },

    startDateFormatted: {
      get: function(){
        return moment(this.startDate,'YYYY-MM-DD').format("Do MMM YYYY")
      }
    },

    endDateFormatted: {
      get: function(){
        return moment(this.endDate,'YYYY-MM-DD').format("Do MMM YYYY")
      }
    }

  },
  methods:{

    onClickRow: function(item){
      let theIndex = this.selectedVehicles.findIndex(vehicle => vehicle.id === item.id)

      if (theIndex > -1) {
        this.selectedVehicles.splice(theIndex, 1);
      }else{
        this.selectedVehicles.push(item);
      }
    },
    onClear:function(){
      this.selectedVehicles = [];
      this.$emit("close")
    },
    onSendEmail: async function()  {
      this.loading = true;

      var vehiclesString = ""
      this.selectedVehicles.forEach((vehicle) => {
        vehiclesString += `&vehicle_id=${vehicle.id}`;
      })


     await Repository.get(`/trip/vehicleMovementReportAll?&mode=email&to_email=${this.$store.state.profile.userInfo.contact.email}&from=${this.startDate}&to=${this.endDate}${vehiclesString}`).then((response) => {
       console.log(response.data)
        this.responseString = response.data.message
        this.pageIndex = 1;
     })

    },

    onCancel:function() {
      this.selectedVehicles = [];
      this.$emit('closeTripDialog')
    },

    onDownload:function() {
      var vehiclesString = ""
      this.selectedVehicles.forEach((vehicle) => {
        vehiclesString += `&vehicle_id=${vehicle.id}`;
      })
      window.open(`https://app.jahazi.com/api/trip/vehicleMovementReportAll?&mode=download&to_email=${this.$store.state.profile.userInfo.contact.email}&from=${this.startDate}&to=${this.endDate}${vehiclesString}`,"_blank");
    }

  },
  mounted() {
    this.selectedVehicles = [];
    if(this.$store.state.vehicles.all.length  <2){
      this.$store.dispatch("vehicles/loadAllItems").then(()=>{
        this.$store.state.vehicles.all.forEach(vehicle => {
          this.selectedVehicles.push(vehicle);
        })
      });
    }else{
      this.$store.state.vehicles.all.forEach(vehicle => {
        this.selectedVehicles.push(vehicle);
      })
    }

  },
}
</script>
<style scoped lang="stylus">
.dateButton2 {
  width: 90%;
  border-radius: 15px;
  padding: 5px 5px;
  max-width: 400px;
}
</style>